import { Navigate } from 'react-router-dom';
import ShiftLogBook from '../../../modules/superAdmin/dashboard';
import ShiftInfoPage from '../../../modules/superAdmin/dashboard/ShiftInfo';
import OperatingInstruction from '../../../modules/superAdmin/OperatingInstruction';
import InfoInstruction from '../../../modules/superAdmin/OperatingInstruction/InfoInstruction';
import OutageRequisition from '../../../modules/superAdmin/OutageRequisition';
import OutageReqDetail from '../../../modules/superAdmin/OutageRequisition/OutrageRequisitionDetail';
import Reports from '../../../modules/superAdmin/Reports';
import Settings from '../../../modules/superAdmin/Settings';
import SpecificInstruction from '../../../modules/superAdmin/SpecificInstruction';
import SpecificInstructionDetails from '../../../modules/superAdmin/SpecificInstruction/SpecificInstructionDetail';
import TemporaryOperatingInstruction from '../../../modules/superAdmin/TemporaryOperatingInstruction';
import TempOperatingInstructionDetails from '../../../modules/superAdmin/TemporaryOperatingInstruction/TempOperatingInstructionDetails';
import LeaveRoster from '../../../modules/superAdmin/LeveRoaster';
import ShiftRoster from '../../../modules/superAdmin/ShiftRoaster';
import ShiftCalendar from '../../../modules/superAdmin/ShiftRoaster/ShiftCalender';
import GroupManagement from '../../../modules/superAdmin/ShiftRoaster/GroupManagement';
import DutyCodeTab from '../../../modules/superAdmin/ShiftRoaster/DutyCardTab';
import LeaveRosterDetails from '../../../modules/superAdmin/LeveRoaster/LeaveRosterDetails';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';

const routes = [
  {
    path: '/ShiftLogbook',
    element: <ShiftLogBook />,
  },
  {
    path: '/ShiftLogbook/:id',
    element: <ShiftInfoPage />,
  },
  {
    path: '/OperatingInstruction',
    element: <OperatingInstruction />,
  },
  {
    path: '/OperatingInstruction/:id',
    element: <InfoInstruction />,
  },
  {
    path: '/TemporaryOperatingInstruction',
    element: <TemporaryOperatingInstruction />,
  },
  {
    path: '/TemporaryOperatingInstruction/:id',
    element: <TempOperatingInstructionDetails />,
  },
  {
    path: '/OutageRequisition',
    element: <OutageRequisition />,
  },
  {
    path: '/OutageRequisition/:id',
    element: <OutageReqDetail />,
  },
  {
    path: '/SpecificInstruction',
    element: <SpecificInstruction />,
  },
  {
    path: '/SpecificInstruction/:id',
    element: <SpecificInstructionDetails />,
  },
  {
    path: '/Report',
    element: <Reports />,
  },
  {
    path: '/LeaveRoster',
    element: <LeaveRoster />,
  },
  {
    path: '/LeaveRoster/:id',
    element: <LeaveRosterDetails />,
  },
  {
    path: '/ShiftRoster',
    element: <ShiftRoster />,
  },

  {
    path: '/ShiftRoster/configuration',
    element: <GroupManagement />,
  },
  {
    path: '/ShiftRoster/configuration/dutycode',
    element: <DutyCodeTab />,
  },
  {
    path: '/ShiftRoster/:id',
    element: <ShiftCalendar />,
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      //{ index: true, element: <UserInfo /> },
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  // 🚫 Catch all undefined or restricted routes
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
];
export default routes;
